import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative overflow-hidden bg-stadium-glow pt-7 pb-12 sm:pt-12 sm:pb-20 md:pt-20 md:pb-32" data-id="element-76">
      <div className="container relative z-10 mx-auto px-4" data-id="element-77">
        <div className="max-w-5xl mx-auto text-center" data-id="element-78">
          <div data-id="element-79">
            <div className="mb-5 inline-flex max-w-full items-center justify-center gap-2 rounded-full border border-gold-500/30 bg-navy-800/80 px-3 py-1.5 text-center font-oswald text-xs uppercase tracking-wide text-gold-400 backdrop-blur-sm sm:mb-6 sm:px-4 sm:text-sm sm:tracking-widest" data-id="element-80">
              <span className="h-2 w-2 flex-shrink-0 rounded-full bg-gold-500 animate-pulse" data-id="element-81" />
              <span data-id="element-82">Proven Coaching System</span>
            </div>

            <h1 className="mb-5 font-anton text-[2.25rem] uppercase tracking-normal leading-[1.05] text-white drop-shadow-2xl sm:text-5xl sm:tracking-wide md:mb-6 md:text-7xl lg:text-8xl" data-id="element-83">
              Stop Planning For Hours. Build Your Entire Basketball Season In{' '}
              <span className="text-gold-500" data-id="element-84">Under 5 Minutes.</span>
            </h1>

            <p className="mx-auto mb-7 max-w-3xl text-base font-medium leading-7 text-gray-300 sm:text-lg md:mb-10 md:text-2xl" data-id="element-85">
              Save time, reduce stress, and develop better players — without
              spending hours planning basketball practices from scratch.
            </p>
          </div>

          <div className="group relative mx-auto mb-7 w-full max-w-[340px] sm:max-w-none md:mb-12" data-id="element-86">
            <div className="absolute -inset-4 rounded-2xl bg-gradient-to-r from-gold-500/20 via-gold-600/20 to-gold-500/20 blur-2xl opacity-50 transition-opacity duration-500 group-hover:opacity-70" data-id="element-87" />
            <img src="https://cdn.magicpatterns.com/uploads/vF1P8TNmaRQc6eH9i9F9uw/ChatGPT_Image_19_jun_2026,_01_16_23.webp" alt="Basketball Ready: System 365 — six coaching volumes and five bonuses" width={1536} height={1024} sizes="(max-width: 639px) 340px, (max-width: 768px) 100vw, 1024px" loading="eager" fetchPriority="high" decoding="async" className="relative h-auto w-full rounded-xl border border-navy-700/50 shadow-2xl" data-id="element-88" />
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="flex flex-col items-center gap-4 md:gap-6" data-id="element-89">
            <Button size="xl" className="flex min-h-[58px] w-full max-w-md flex-col items-center sm:w-auto" onClick={() => document.getElementById('offer')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })} data-id="element-90">
              <span data-id="element-91">YES, I WANT MY SYSTEM NOW →</span>
              <span className="mt-1 font-inter text-xs font-normal normal-case opacity-90" data-id="element-92">
                Start coaching with structure tonight.
              </span>
            </Button>

            <div className="flex flex-col items-center gap-2 px-2 text-center md:gap-3" data-id="element-93">
              <div className="flex items-center justify-center gap-1" data-id="element-94">
                {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 fill-gold-500 text-gold-500 sm:h-5 sm:w-5" data-id="element-95" />)}
              </div>
              <div className="font-oswald text-sm text-gray-200 sm:text-lg" data-id="element-96">
                4.9/5 — Verified Reviews | Trusted by 3,000+ Basketball Coaches
                Worldwide
              </div>
              <div className="flex items-center justify-center gap-2 text-center text-xs font-medium text-gray-400 sm:text-sm" data-id="element-97">
                <ShieldCheck className="h-4 w-4 flex-shrink-0 text-green-500" data-id="element-98" />
                <span data-id="element-99">7-Day Money Back Guarantee — Zero Risk</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}